exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-column-dialog-body-3wpdy{padding-left:20px}.style-column-dialog-body-3wpdy .style-column-dialog-item-6Qktk{display:flex;align-items:center;justify-content:center}.style-column-dialog-body-3wpdy .style-column-dialog-item-6Qktk:first-child{margin-bottom:10px}.style-column-dialog-body-3wpdy .style-column-dialog-item-6Qktk label{margin-left:auto;margin-right:10px}", ""]);

// Exports
exports.locals = {
	"column-dialog-body": "style-column-dialog-body-3wpdy",
	"column-dialog-item": "style-column-dialog-item-6Qktk"
};